<template>
    <v-dialog v-model="showModal"
              max-width="85%"
              persistent
              width="fit-content">
      <v-icon aria-label="Close"
              class="close-content-btn"
              @click="closeModal()">mdi-close</v-icon>
      <div v-if="type.startsWith('image')">
        <img
            class="content-file-attachment"
            :src="source"
            width="100%"
            height="100%"
        />
      </div>
      <div v-else-if="source">
        <video class="content-file-attachment" width="100%" height="100%" controls>
          <source :src="source"
                  type="video/mp4">
        </video>
      </div>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            showModal: false,
            source: '',
            type: ''
        }
    },
    created() {
      Bus.$on('view-file-attachment', (item) => {
        this.source = item.fileUrl;
        this.type = item.fileType;
        this.showModal = true
      })
    },
    methods: {
        closeModal() {
            this.showModal = false;
            this.type = "";
            this.source = "";
            // $('#video-player').trigger('pause');
        }
    }
}
</script>

<style scoped>
/deep/ .v-expansion-panel-header {
    padding: 10px;
    background-color: #e6f2ff;
    border: 1px solid #e2e2e2;
    font-size: 16px;
    min-height: 40px;
}

/deep/ .v-expansion-panel-content__wrap {
    padding: 10px;
    border: 1px solid #e2e2e2;
}

/deep/ .text-content-container table {
  width: 100%;
  border-collapse: collapse;
}

/deep/ .text-content-container table td{
  border: 2px solid black;
  padding: 4px;
}

/deep/ .v-dialog:not(.v-dialog--fullscreen) {
  position: relative;
  overflow-y: inherit;
}

/deep/ .v-card__text {
  height: 90%;
  overflow-y: auto;
}
/deep/ .content-file-attachment {
  display: block;
  max-width: 90vw;
  width: auto;
  max-height: 90vh;
  height: auto;
  margin: 0 auto;
}
/deep/ .close-content-btn {
  cursor: pointer;
  width: fit-content;
  position: absolute;
  background: white;
  right: -10px;
  top: -10px;
  border-radius: 50%;
}
</style>